(ns hai.sharing.recipients
  "Who typed text can add to an entity's shares: the contacts found for it and
   the address or the email domain it spells, each placed against who the
   entity is already shared with."
  (:require
   [clojure.string :as str]
   [humbleai.belt.malli.type.domain :as type.domain]
   [humbleai.belt.malli.type.email :as type.email]))

(defn- addresses
  "`value`, one address or several, in lower case."
  [value]
  (map str/lower-case (cond
                        (nil? value) []
                        (coll? value) value
                        :else [value])))

(defn- contact-recipient [contact]
  {:kind :contact
   :key (str (:contact/uuid contact))
   :contact contact})

(defn typed-recipient
  "The recipient `text` spells by itself: an address, or an email domain with
   or without its @. nil for anything else."
  [text]
  (let [typed (str/lower-case (str/trim text))
        host (str/replace typed #"^@" "")]
    (cond
      (type.email/email? typed) {:kind :email :key typed :email typed}
      (type.domain/domain? host) {:kind :domain :key host :domain host})))

(defn- holder
  "Whoever among `people` `recipient` already is: the audience of its domain,
   or the person with one of its addresses."
  [people {:keys [kind contact email domain]}]
  (if (= :domain kind)
    (some #(when (= domain (some-> (:scope %) str/lower-case)) %) people)
    (let [wanted (set (if (= :contact kind)
                        (addresses (:contact/email contact))
                        [email]))]
      (some #(when (some wanted (addresses (get-in % [:person :user/email]))) %) people))))

(defn- notice
  [text typed picked-keys]
  (let [trimmed (str/trim text)]
    (cond
      (str/blank? trimmed) nil
      (and typed (contains? picked-keys (:key typed))) "Already added below"
      (pos? (or (str/index-of trimmed "@") -1)) "Keep typing a full email address"
      :else "No contacts match. Type an email address to add someone.")))

(defn suggestions
  "What `text` offers to share with, best first and `limit` at most: the
   `contacts` found for it, then the address or the domain it spells, unless a
   found contact has that address. Text starting with @ offers only its domain.
   Whatever is `picked` already is left out.

   Each of `:rows` is `{:recipient … :holder-key …}`, `:holder-key` the `:key`
   of whoever among `people`, the rows the Share tab lists, the recipient
   already is. With no rows, `:notice` says why."
  [{:keys [text contacts people picked limit]}]
  (let [picked-keys (into #{} (map :key) picked)
        unpicked? #(not (contains? picked-keys (:key %)))
        found (if (str/starts-with? (str/trim text) "@")
                []
                (filter unpicked? (map contact-recipient contacts)))
        found-addresses (into #{} (mapcat #(addresses (get-in % [:contact :contact/email]))) found)
        typed (typed-recipient text)
        spelled (when (and typed
                           (unpicked? typed)
                           (not (contains? found-addresses (:email typed))))
                  typed)
        offered (cond-> (vec (take (cond-> limit spelled dec) found))
                  spelled (conj spelled))
        rows (mapv (fn [recipient]
                     {:recipient recipient
                      :holder-key (:key (holder people recipient))})
                   offered)]
    {:rows rows
     :notice (when (empty? rows)
               (notice text typed picked-keys))}))
